import type { ProposalItem, ProposalStatus } from "../types";

export const PROPOSAL_STATUSES: ProposalStatus[] = [
  "draft",
  "sent",
  "accepted",
  "rejected",
];

export const PROPOSAL_STATUS_COLORS: Record<ProposalStatus, string> = {
  draft: "#8e8e98",
  sent: "#2f6bff",
  accepted: "#3dd68c",
  rejected: "#ff6b5d",
};

export const monthlyTotal = (items: ProposalItem[]): number =>
  items.reduce((sum, item) => sum + (Number(item.monthly_price) || 0), 0);

/** Date-only string 30 days from today, in local time. */
export const defaultValidUntil = (): string => {
  const date = new Date();
  date.setDate(date.getDate() + 30);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};
